import { CommonColors } from '@/Themes';
import { SxProps, Theme } from '@mui/system';

export const buttonFilter: SxProps<Theme> = {
  background: CommonColors.bismark,
  '&:hover': {
    background: '#486270',
  },
};
